var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import RadImg from '../../../../_rad/client/components/ui/img';
const DEFAULT_PLACEHOLDER = '/images/placeholder/560x320.svg';
const Img = (_a) => {
    var { placeholder = DEFAULT_PLACEHOLDER } = _a, rest = __rest(_a, ["placeholder"]);
    return (_jsx(RadImg, Object.assign({ placeholder: placeholder }, rest)));
};
export default Img;
